'use strict'

import ApiClient from './ApiClient'

export default class TopRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * システムの状況を取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/`)
  }

  /**
   * サイドメニュー情報取得
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  getSidemenu (isMgmt) {
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/sidemenu`, { params })
  }

  // /**
  //  * TOP画面に必要な情報を取得
  //  * @returns {*}
  //  */
  // getTop () {
  //   return ApiClient().get(`/top`, {params: {type: '0'}})
  // }
  //
  // /**
  //  * ライセンス情報を取得します
  //  * @returns {*}
  //  */
  // getLicSummary () {
  //   return ApiClient().get(`/licenses/summary`)
  // }
  //
  /**
   * お知らせ一覧を取得します。（指定したタイプによるLIMITが自動で付与される）
   * @param {object} params
   * @returns {*}
   */
  getInfoMessages (params) {
    return ApiClient().get(`/info-messages/top`, { params })
  }

  // /**
  //  * 最近交換した名刺一覧を取得します。（指定したタイプによるLIMITが自動で付与される）
  //  * @param {object} params
  //  * @returns {*}
  //  */
  // getExBcards (params) {
  //   return ApiClient().get(`/exchanged-bcards/top`, { params })
  // }
  //
  // /**
  //  * 最近見た名刺一覧を取得します。（指定したタイプによるLIMITが自動で付与される）
  //  * @param {object} params
  //  * @returns {*}
  //  */
  // getAccBcards (params) {
  //   return ApiClient().get(`/accessed-bcards/top`, { params })
  // }
  //
  // /**
  //  * 最近更新された名刺一覧を取得します。（指定したタイプによるLIMITが自動で付与される）
  //  * @param {object} params
  //  * @returns {*}
  //  */
  // getUpdBcards (params) {
  //   return ApiClient().get(`/updated-bcards/top`, { params })
  // }
  //
  // /**
  //  * お気に入り名刺一覧を取得します。（指定したタイプによるLIMITが自動で付与される）
  //  * @param {object} params
  //  * @returns {*}
  //  */
  // getFavBcards (params) {
  //   return ApiClient().get(`/favorited-bcards/top`, { params })
  // }
  //
  // /**
  //  * 画像からの登録状況一覧情報を取得します。（指定したタイプによるLIMITが自動で付与される）
  //  * @param {object} params
  //  * @returns {*}
  //  */
  // getBcardImages (params) {
  //   return ApiClient().get(`/bcard-images/top`, { params })
  // }
}



// WEBPACK FOOTER //
// ./src/repositories/TopRepository.js